/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable react/no-unknown-property */
import React, { Component } from 'react';
import moment from "moment";
import PropTypes from 'prop-types';
import _, { isNull, isUndefined } from 'lodash';
import { connect } from 'react-redux';
import { Img } from 'react-image'
import {
  CommentContent, CommentSection, StyledLink, TimeContent, ViewMoreLink, CommentsContainer, TextFieldContainer, SingleComment,
  ImageWrapper,
  TimeContentV2, InputFieldContainer, CommentsWrapper
} from './styles';
import { FieldContainer,/* InputImage*/ } from '../EventDetails/styles';
import { DownAngle, RecognitionSection, RecognitionText, SendButton, CommentBoxWrap, ReplyTextPopup, MaxText, DownAngleV2, UserInitialsMain } from '../SocialFeedsV2/styles';
import { convertDateInTimezone, convertUnicode, applyHighlights, getDecodedString, checkImage, getOrientation, resetOrientation, convertMonthFromDate, getInitials } from '../../utils/methods';
import { getUserName, getUserProfileImage, getUserId, getUserPosts, likeUnlikePostComment, disableButton, likeUnlikeCommentReply, addCommentReplyOnPost, editCommentOnPost,editCommentReplyOnPost } from '../../redux/actions';
import { ImageUrl } from '../../utils/constants';
import { withTranslation } from 'react-i18next';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
const DeleteCommentPopup = React.lazy(() => import('./deleteCommentPopup'));
import ReplySectionTextArea from '../SocialFeedsV2/ReplySectionTextArea';
import SocialFeedsEmojiPicker from '../SocialFeedsEmojiPicker';
import DOMPurify from 'dompurify';
import { IconContainer } from '../EventDetails/styles';
import { EmojiCommentIcon, ReplyCommentIcon, VerticalDotsIcon } from '../../utils/icons';

class Comments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      replyTextField: '',
      replyText: '',
      replyCount: 3,
      isUpdatedImage: false,
      mentionedUsers: [],
      users: [],
      showGivenShoutout: false,
      shoutoutText: null,
      shoutoutImage: null,
      userIdArray: [],
      taggedUser: '',
      shoutoutType: 0,
      exemplifyID: null,
      ShowEmojiContainer: false,
      displayEmojiPicker: false,
      isPostLiked: props.feed.liked_status === 1,
      clicked: false,
      likeStatus: false,
      commentId: '',
      showDeleteCommentPopup: false,
      DeleteComment: false,
      imgSrcV2: [],
      messageLength: 0,
      deleteCommentId: null,
      position: { start: 0, end: 0 },
      initialReply:true,
      tagUserName:'',
      pageNumber:1,
      replySubmitting: false,
      editingCommentId: null,
      editCommentText: '',
      originalCommentText: '',
      editedCommentIds: [],
      dropdownOpen: null,
      editingReplyId: null,
      editReplyText: '',
      originalReplyText: '',
      editedReplyIds: [],
      displayReplyEmojiPicker: false,
      replyDropdownOpenId: null,
    }
    this.myref = React.createRef();
    this.emojiref = React.createRef();
  }


  handleClick = (event) => {
    if ((this.state.replyTextField === '') && !isNull(this.myref) && !isUndefined(this.myref) && !(this.myref && !isNull(this.myref.current) && !isUndefined(this.myref.current) && this.myref.current.contains(event.target))) {
      this.setState({ ShowEmojiContainer: false });
    }
  };
  handleEmojiClick = (event) => {
    if (!isNull(this.emojiref) && !isUndefined(this.emojiref) && !(this.emojiref && this.emojiref.current && this.emojiref.current.contains(event.target))) {
      this.setState({ displayEmojiPicker: false });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick);
    // this.replyClick && document.addEventListener("mousedown", this.replyClick);
    // document.addEventListener("mousedown", this.handleEmojiClick);
    if (!this.props.userName) this.props.fetchUserName();
    if (!this.props.profileImage) this.props.fetchUserProfileImage();
    if (!this.props.userId) this.props.fetchUserId();
    this.checkBase64(this.props.profileImage);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.replySuccess) {
      this.setState({
        replyText: '',
        replyTextField: ''
      });
    }
    if (this.props.profileImage != nextProps.profileImage) {
      this.checkBase64(nextProps.profileImage)
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
    document.removeEventListener("mousedown", this.handleEmojiClick);
  }

  createSafeHTML = (htmlString) => {
    const sanitizedHTML = DOMPurify.sanitize(htmlString);
    const range = document.createRange();
    const fragment = range.createContextualFragment(sanitizedHTML);
    return fragment; 
  };

  checkBase64(profileImage) {
    if (profileImage) {
      let arr = profileImage.split('/');
      if (arr[0] !== 'profile-Image') {
        this.setState({
          isUpdatedImage: true
        })
      }
      else {
        this.setState({
          isUpdatedImage: false
        })
      }
    }
  }

  getPosition(el) {
    let start = 0, end = 0, normalizedValue, range,
      textInputRange, len, endRange;

    if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el?.value?.replace(/\r\n/g, "\n");
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd("character", -len);
            end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }

    return {
      start: start,
      end: end
    };
  }
   
  toCodePoints = function (string) {
    let chars = "";
    for (let i = 0; i < string.length; i++) {
      let c1 = string.charCodeAt(i);
      let b1 = string.charAt(i);
      if (c1 >= 0xD800 && c1 < 0xDC00 && i + 1 < string.length) {
        let c2 = string.charCodeAt(i + 1);
        if (c2 >= 0xDC00 && c2 < 0xE000) {
          chars = chars + ("&#" + ((+0x10000 + ((c1 - 0xD800) << 10) + (c2 - 0xDC00))) + ";");
          i++;
          continue;
        }
      }
      chars = chars + b1;  // always append b1 — moved outside the else
    }
    return chars;
  }


  onChangeValue = (e, name) => {
    let position = e ? this.getPosition(e.target) : { start: name.length, end: name.length };
    let text = e ? e.target.value : name;
  
    // Allow user to remove characters if they exceed the limit
    if (text.length <= 600) {
      this.setState({
        replyText: text,
        position: position
      });
    } else {
      // Prevent adding more characters beyond the limit
      this.setState({
        replyText: text.slice(0, 600),
        position: position
      });
    }
  };

  addInspirationV2 = (native) => {
    let newText = this.state.replyText.slice(0, this.state.position.start) + native + this.state.replyText.slice(this.state.position.end);
    this.setState({
      position: { start: this.state.position.start + native.length, end: this.state.position.end + native.length },
      replyText: newText,
    });
  };

  // addReply = async (e, commentId) => {
  //   e.preventDefault();
  
  //   if (this.state.replySubmitting || !this.state.replyText.trim()) return;
    
  
  //   const {
  //     users,
  //     userIdArray,
  //     replyText,
  //     taggedUser,
  //     mentionedUsers,
  //     exemplifyID,
  //     imgSrcV2,
  //   } = this.state;
  //   const { postReply, id } = this.props;
  
  //   this.setState({ replySubmitting: true, replyText: '' }); 
  
  //   try {
  //     let shoutout = {
  //       exemplifies: mentionedUsers.length > 0 ? mentionedUsers : userIdArray,
  //     };
  
  //     let reply = this.toCodePoints(replyText);
  //     let shoutOutUserName;
  
  //     if (
  //       (!_.isEmpty(mentionedUsers) || !_.isEmpty(userIdArray)) &&
  //       users &&
  //       taggedUser
  //     ) {
  //       shoutOutUserName = `${applyHighlights(
  //         users,
  //         userIdArray,
  //         taggedUser
  //       )} - ${this.state.shoutoutText}`;
  //     }
  
  //     let exemplify_id = exemplifyID;
  //     reply = this.addhightLight(reply, this.state.tagUserName);
  
  //     await postReply(
  //       commentId,
  //       reply,
  //       id,
  //       shoutout.exemplifies,
  //       shoutOutUserName,
  //       exemplify_id,
  //       imgSrcV2.length >= 1 ? imgSrcV2[0] : ''
  //     );
  
      
  //     this.setState({
  //       showTextAreaFor: null,
  //       reply: '',
  //       showGivenShoutout: false,
  //       shoutoutImage: null,
  //       shoutoutText: null,
  //       thankYou: [],
  //       congrats: [],
  //       jobWellDone: [],
  //       taggedUser: '',
  //       userIdArray: [],
  //       users: [],
  //       imgSrcV2: [],
  //       messageLength: 0,
  //     });
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     this.setState({ replySubmitting: false });
      
  //   }
  // };

  addReply = (e, commentId) => {
    e.preventDefault();
    const { users, userIdArray, replyText, taggedUser, mentionedUsers, exemplifyID, imgSrcV2 } = this.state;
    const { postReply, id } = this.props;
    let shoutout = {
      exemplifies: mentionedUsers.length > 0 ? mentionedUsers : userIdArray
    }
    let reply = this.toCodePoints(replyText), shoutOutUserName;
    if (!_.isEmpty(mentionedUsers) || !_.isEmpty(userIdArray) && users && taggedUser) {
      shoutOutUserName = `${applyHighlights(users, userIdArray, taggedUser)} - ${this.state.shoutoutText}`;
    }
    let exemplify_id = exemplifyID;
    // let image = "";
    reply=this.addhightLight(reply, this.state.tagUserName);
    postReply(commentId, reply, id, shoutout.exemplifies, shoutOutUserName, exemplify_id, imgSrcV2.length >= 1 ? imgSrcV2[0] : '');
    this.setState({
      showTextAreaFor: null,
      reply: '',
      showGivenShoutout: false,
      shoutoutImage: null,
      shoutoutText: null,
      thankYou: [],
      congrats: [],
      jobWellDone: [],
      taggedUser: '',
      userIdArray: [],
      users: [],
      imgSrcV2: [],
      messageLength: 0,
      initialReply: true,
      tagUserName: '', 
    });
  };


  removeImage = () => {
    this.setState({
      imgSrcV2: [],
      messageLength: 0
    });
  };

  onChangeImage = (e) => {
    let file = e.target.files[0];
    this.setState({
      messageLength: e.target.value.length >= 1 ? "1" : '0'
    });
    if (checkImage(e.target.files)) {
      if ((file?.size / 1000000) <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({
            imgSrcV2: [reader.result],
            refreshFileReader: true,
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrcV2: [baseImage],
                refreshFileReader: false
              });
            });
          });
        };
      } else {
        toast.error('Please select image file less than 20MB');
        document.getElementById('replyPhoto').value = '';
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById('replyPhoto').value = '';
    }
  };

  showTextField = (id, name, uid) => {
    const { replyTextField, userIdArray } = this.state;
    let userIdArr = [...userIdArray];
    if (userIdArr.indexOf(uid) === -1) {
      userIdArr.push(uid);
    }
    this.setState({
      replyTextField: replyTextField === id ? '' : id,
      replyText: '',          
      userIdArray: userIdArr,
      initialReply: true,     
      tagUserName: name      
    })
  };


  showMoreReplies = (replyCount) => {
    this.setState({
      replyCount
    });
  };

  containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png");
    return defaultPngFound;
  }
  handleDropdownToggle = (isOpen, commentId) => {
    this.setState({ dropdownOpenId: isOpen ? commentId : null });
  };

  handleReplyDropdownToggle = (isOpen, replyId) => {
    this.setState({ replyDropdownOpenId: isOpen ? replyId : null });
  };

  showReplyEmojiPicker = () => {
    this.setState((prev) => ({
      displayReplyEmojiPicker: !prev.displayReplyEmojiPicker
    }));
  };


  handleEditClick = (e, commentId, comment) => {
    e.stopPropagation();
    this.setState({ dropdownOpenId: null });
    this.startEditComment(commentId, comment);
  };

 

  startEditReply = (replyId, replyText) => {
    const decoded = this.decodeHTMLEntities(getDecodedString(replyText));
    this.setState({
      editingReplyId: replyId,
      editReplyText: decoded,
      originalReplyText: decoded,
    });
  };

  cancelEditReply = () => {
    this.setState({ editingReplyId: null, editReplyText: '' });
  };

  saveEditReply = (parentCommentId, replyId) => {
    const { editReplyText, originalReplyText, editedReplyIds } = this.state;
    const { editCommentReply, id } = this.props;
    if (editReplyText.trim() === '' || editReplyText === originalReplyText) {
      this.cancelEditReply();
      return;
    }
    editCommentReply(parentCommentId, replyId, editReplyText, id); 
    this.setState({ editedReplyIds: [...editedReplyIds, replyId] });
    this.cancelEditReply();
  };



  showProfileImage = (comment, isOwn) => {
    const { userId, profileImage } = this.props;
    const { isUpdatedImage } = this.state;
    if (isOwn) {
      if (isUpdatedImage) {
        return (!this.containsDefaultPng(profileImage)?<img src={profileImage} />:<UserInitialsMain isBg  border color={"#184A61"} isWidth={"48px"} isHeight={"48px"}  >{`${getInitials(comment)}`}</UserInitialsMain>)
      }
      else {
        // return (<Image image={profileImage} />)
        return (!this.containsDefaultPng(profileImage)?<img src={ImageUrl+"/"+profileImage} />:<UserInitialsMain isBg  border color={"#184A61"} isWidth={"48px"} isHeight={"48px"}  >{`${getInitials(comment)}`}</UserInitialsMain>)
      }
    } else if (userId === comment.uid) {
      if (isUpdatedImage) {
        return (!this.containsDefaultPng(profileImage)?<img src={profileImage} />:<UserInitialsMain isBg  border color={"#184A61"} isWidth={"48px"} isHeight={"48px"} >{`${getInitials(comment?.user_name)}`}</UserInitialsMain>)
      }
      else {
        return (!this.containsDefaultPng(profileImage)?<img src={ImageUrl+"/"+profileImage} />:<UserInitialsMain isBg  border color={"#184A61"} isWidth={"48px"} isHeight={"48px"} >{`${getInitials(comment?.user_name)}`}</UserInitialsMain>)
      }
    }
    else {
      return (!this.containsDefaultPng(comment?.profile_image)?<img src={ImageUrl+"/"+comment?.profile_image} />:<UserInitialsMain isBg  border color={"#184A61"} isWidth={"48px"} isHeight={"48px"} >{`${getInitials(comment?.user_name)}`}</UserInitialsMain>)
    }
  };

  updateText = (text, userId, taggedUserName, bool) => {
    const { userIdArray, users, taggedUser } = this.state;
    let userIdArr = [...userIdArray];
    let userNameArr = [...users];
    let taggedUsers = taggedUser;
    if (userIdArr.indexOf(userId) === -1) {
      userIdArr.push(userId);
      userNameArr.push(taggedUserName);
      if (!_.isEmpty(taggedUsers))
        taggedUsers = `${taggedUsers}, ${taggedUserName}`;
      else
        taggedUsers = taggedUserName;
    }
    this.setState({
      replyText: text,
      userIdArray: userIdArr,
      users: userNameArr,
      taggedUser: taggedUsers,
      showGivenShoutout: bool
    });
  };

  updateShoutoutArray = (mentionedUsers, text, image, exemplifies_id) => {
    this.setState({
      showGivenShoutout: true,
      shoutoutText: text,
      shoutoutImage: image,
      shoutoutType: exemplifies_id ? exemplifies_id : null,
      mentionedUsers: mentionedUsers,
      exemplifyID: exemplifies_id ? exemplifies_id : null
    });
    this.displayEmojiContainer();
  };

  onRemoveShoutout = (array) => {
    this.setState({
      [array]: [],
      showGivenShoutout: false,
      taggedUser: '',
      shoutoutImage: null,
      shoutoutText: null,
      userIdArray: [],
      users: [],
      shoutoutType: 0,
      mentionedUsers: []
    });
  };

  onEmojiSelect = (emoji, id, native, skin) => {
    this.setState({
      emojiData: emoji,
      emojiId: id,
      emojiNative: native,
      emojiSkin: skin
    })
    this.addInspirationV2(native);
  }
  onEditEmojiSelect = (emoji, id, native, skin) => {
    this.setState((prev) => ({
      emojiData: emoji,
      emojiId: id,
      emojiNative: native,
      emojiSkin: skin,
      editCommentText: prev.editCommentText + native,
    }));
  };



  onRemoveUser = () => {
    this.setState({
      taggedUser: '',
      showGivenShoutout: false,
      userIdArray: [],
      shoutoutImage: null,
      shoutoutText: null,
      users: []
    });
  };

  togglePostButton = (value) => {
    const { shoutoutText, userIdArray } = this.state;
    if (userIdArray.length !== 0) {
      if (userIdArray.length !== 0 && !_.isNull(shoutoutText)) {
        return false;
      } else
        return true;
    } else if (value && value.trim() !== '') {
      return false;
    }
    return true;
  };

  displayEmojiContainer = () => {
    this.setState((prev) => ({
      ShowEmojiContainer: !prev.ShowEmojiContainer
    }));
  }

  showEmojiPicker = () => {
    this.setState((prev) => ({
      displayEmojiPicker: !prev.displayEmojiPicker
    }))
  }

  likeUnlikePost = (id, likestatus) => {
    const { likeUnlikePostComment, feed, disableLikeButton } = this.props;
    const likeData = {
      comment_id: id,
      flag: likestatus === 1 ? 'unlike' : 'like',
    };
    this.setState({
      commentId: id
    });
    disableLikeButton();
    likeUnlikePostComment(likeData, feed.id);
  };
  likeUnlikePostCommentReply = (id, likestatus, commentId) => {
    const { likeUnlikeCommentReply, feed, disableLikeButton } = this.props;
    const likeData = {
      reply_id: id,
      flag: likestatus === 1 ? 'unlike' : 'like',
      comment_id: commentId
    };
    this.setState({
      commentId: id
    });
    disableLikeButton();
    likeUnlikeCommentReply(likeData, feed.id);
  };

  addhightLight = (string, parameter)=> {
    const strWords = string.split(' '); // split string into words
    const paramWords = parameter.split(' '); // split parameter into words
    if (strWords.slice(0, paramWords.length).join(' ') === parameter) {
      for (let i = 0; i < paramWords.length; i++) {
        strWords[i] = '<b>' + strWords[i] + '</b>'; // add bold tags to matching words
      }
    }
    return strWords.join(' '); // join words back into a string
  }

  decodeHTMLEntities = (text) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = text;
    return txt.value;
  };
  
  renderTextArea = (value, id, name) => {
    const { noFloat, enableTrigger } = this.props;
    // if (name && !this.state.replyText && this.state.initialReply) {
    //   this.setState({
    //     initialReply:false,
    //     tagUserName:name
    //   })
    //   this.onChangeValue(false, name);
    // }
    return (
      <TextFieldContainer noFloat={noFloat} >
        <CommentContent noFloat={noFloat}>
          <ImageWrapper comment={1} >
            {this.showProfileImage(this.props.userName, true)}
          </ImageWrapper>
          <InputFieldContainer comment name={name} height={this.state.showGivenShoutout || this.state.imgSrcV2.length ? 'auto' : 'auto'} padding={'0px'} flex={1} border="none !important" style={{borderRadius:"20px !important"}}>
            <ReplySectionTextArea
              replyCommentName={name}
              userCompany={this.props.userCompany}
              addInspiration={this.onChangeValue}
              inspirationQuote={value}
              updateText={this.updateText}
              users={this.state.users}
              userIdArray={this.state.userIdArray}
              placeholder={" Write your reply"}
              showGivenShoutout={this.state.showGivenShoutout}
              updateShoutoutArray={this.updateShoutoutArray}
              emptyShoutoutArray={this.emptyShoutoutArray}
              onRemoveShoutout={this.onRemoveShoutout}
              isCommentOrReply={"isCommentOrReply"}
              shoutoutText={this.state.shoutoutText}
              shoutoutImage={this.state.shoutoutImage}
              taggedUser={this.state.taggedUser}
              onRemoveUser={this.onRemoveUser}
              enableTrigger={enableTrigger}
              ShowEmojiContainer={this.state.ShowEmojiContainer}
              myref={this.myref}
              showEmojiPicker={this.showReplyEmojiPicker}
              displayEmojiPicker={this.state.displayReplyEmojiPicker}
              closeEmojiContainer={this.displayEmojiContainer}
              emojiRef={this.emojiref}
              comments={this.props.comments}
              selectedImage={this.state.imgSrcV2[0]}
              removeImage={this.removeImage}
              addInspirationV2={this.addInspirationV2}
            />
          </InputFieldContainer>
        </CommentContent>
        <RecognitionSection float={'right'} width={'35%'} height={'none'} display={'flex-end'} reply={1} style={{width:"100%"}}>
          <div style={{display: "flex", margin: "auto", marginBottom: "5px", marginLeft: "50px", marginTop:"10px"}}>
            <div style={{width:"46px", height:"46px", border:"1px solid #005C874D", display:"flex", borderRadius:"50%",marginRight:"0px"}}>
              <img style={{ marginTop: '0px', cursor: 'pointer', width: '27px', height: '27px', margin:"auto" }} onClick={this.showEmojiPicker} src={ImageUrl+"/social-feed/Emoji.png"}></img>
            </div>
            <SendButton disabled={this.state.replyText.length > 0 || this.state.imgSrcV2.length>0?0:1} style={{marginRight:"0px"}} onClick={this.state.replyText.length > 0 || this.state.imgSrcV2.length>0? (e) => this.addReply(e, id):null}>
              <img src={ImageUrl + "/social-feed/sendButton.png"} />
            </SendButton>
          </div>
        </RecognitionSection>
        {this.state.displayReplyEmojiPicker ? <SocialFeedsEmojiPicker comment selectEmoji={this.onEmojiSelect} hidePicker={this.showReplyEmojiPicker} isCommentModal={this.props.isCommentModal} /> : null}
      </TextFieldContainer>
    );
  };

  renderCommentArea = (value, id, name) => {
    const { enableTrigger } = this.props;
    if (name && !this.state.replyText && this.state.initialReply) {
      this.setState({
        initialReply: false,
        tagUserName: name
      });
    }
    return (
      <>
        <CommentBoxWrap width={"100%"} style={{marginTop:"8px", marginLeft:"60px"}}>
          <div className='profile-picture'>
            {this.showProfileImage(this.props.userName, true)}
          </div>
          <ReplyTextPopup border={this.state.replyText?.length > 500} width={this.state.replyText?.length > 0?"100% !important":"80%"}>
            <ReplySectionTextArea
              replyCommentName={name}
              userCompany={this.props.userCompany}
              addInspiration={this.onChangeValue}
              inspirationQuote={value}
              updateText={this.updateText}
              users={this.state.users}
              userIdArray={this.state.userIdArray}
              placeholder={" Write your reply"}
              showGivenShoutout={this.state.showGivenShoutout}
              updateShoutoutArray={this.updateShoutoutArray}
              emptyShoutoutArray={this.emptyShoutoutArray}
              onRemoveShoutout={this.onRemoveShoutout}
              isCommentOrReply={"isCommentOrReply"}
              shoutoutText={this.state.shoutoutText}
              shoutoutImage={this.state.shoutoutImage}
              taggedUser={this.state.taggedUser}
              onRemoveUser={this.onRemoveUser}
              enableTrigger={enableTrigger}
              ShowEmojiContainer={this.state.ShowEmojiContainer}
              myref={this.myref}
              showEmojiPicker={this.showReplyEmojiPicker}
              displayEmojiPicker={this.state.displayReplyEmojiPicker}
              closeEmojiContainer={this.displayEmojiContainer}
              emojiRef={this.emojiref}
              comments={this.props.comments}
              selectedImage={this.state.imgSrcV2[0]}
              removeImage={this.removeImage}
              addInspirationV2={this.addInspirationV2}
              isReplyTextArea={"1"}
            />
            {this.state.replyText?.length > 0?
              <IconContainer isColor={this.state.replyText?.length>500} width="100% !important" cameraIcon style={{ width:"100% !important",justifyContent: "space-between", position:"initial", display: "flex", margin: "8px auto auto auto" }}>
                <div style={{width:"24px", height:"24px", display:"flex"}}>
                  <div style={{ marginTop: '0px', cursor: 'pointer', margin:"auto" }} onClick={this.showReplyEmojiPicker}>{EmojiCommentIcon()}</div>
                </div>
                <div className="commentBox">
                  <div className="commentLength">{this.state.replyText.length}/500 | C</div>
                  <div className='sendbutton'
                    // style={{ cursor: this.state.replySubmitting ? 'not-allowed' : 'pointer', opacity: this.state.replySubmitting ? 0.6 : 1 }}
                    onClick={
                      this.state.replyText.trim().length === 0 || this.state.replyText.length > 500 || this.state.replySubmitting
                        ? null
                        : (e) => this.addReply(e, id)
                    }
                  >
                    Reply
                  </div>
                </div>
              </IconContainer>:
              <IconContainer cameraIcon style={{ width:"20% !important",justifyContent: "flex-end", position:"initial", marginTop:"0px", display: "flex", margin: "auto 0 auto auto" }}>
                <div style={{width:"24px", height:"24px", display:"flex", borderRadius:"50%"}}>
                  <div style={{ marginTop: '0px', cursor: 'pointer', margin:"auto" }} onClick={this.showReplyEmojiPicker}>{EmojiCommentIcon()}</div>
                </div>
              </IconContainer>}
          </ReplyTextPopup>
        </CommentBoxWrap>
        {this.state.displayReplyEmojiPicker ? <SocialFeedsEmojiPicker comment selectEmoji={this.onEmojiSelect} hidePicker={this.showReplyEmojiPicker} isCommentModal={this.props.isCommentModal} /> : null}
      </>
    )
  }

  getTaggedUserId = (e) => {
    const { history, userId, fetchUserPosts } = this.props;
    fetchUserPosts(e.target.id, history);
    if (e.target.id) {
      if (userId === e.target.id) {
        history.push('/profile');
      } else {
        history.push(`/profile/${e.target.id}`);
      }
    }
  };

  likePost = () => {
    this.setState((prev) => ({
      likeStatus: !prev.likeStatus
    }))
  }

  changeDeleteCommentPopup = (value, id) => {
    this.setState({ showDeleteCommentPopup: value, deleteCommentId: id });
  };



  startEditComment = (commentId, commentText) => {
    const decoded = this.decodeHTMLEntities(getDecodedString(commentText));
    this.setState({
      editingCommentId: commentId,
      editCommentText: decoded,
      originalCommentText: decoded,
      dropdownOpenId: null,
    });
  };



  cancelEditComment = () => {
    this.setState({ editingCommentId: null, editCommentText: '' });
  };

  saveEditComment = (commentId) => {
    const { editCommentText, originalCommentText, editedCommentIds } = this.state;
    const { editComment, id } = this.props;
    if (editCommentText.trim() === '' || editCommentText === originalCommentText) {
      this.cancelEditComment();
      return;
    }
    console.log('Saving comment:', JSON.stringify(editCommentText));  // ADD THIS
    editComment(commentId, editCommentText, id);
    this.setState({ editedCommentIds: [...editedCommentIds, commentId] });
    this.cancelEditComment();
  };





  openDeleteComment = () => {
    this.setState({
      DeleteComment: !this.state.DeleteComment
    })
  };


  onHideDeleteCommentPopup = () => {
    this.setState({
      showDeleteCommentPopup: ''
    }, () => {
      this.openDeleteComment();
    })
  };

  render() {
    const { comments, fixHeight, noFloat, showThreeComments, t, isFlaggedPost } = this.props;
    const { replyTextField, replyText, replyCount, editingCommentId, editCommentText } = this.state;
    return (
      <>
        <CommentsContainer noFloat={noFloat}>
          <FieldContainer fixHeight={fixHeight} commentsSection noFloat={noFloat} >
            {
              showThreeComments ? comments && comments.map((comment, index) => {
                const TimeOfComment = convertMonthFromDate(moment(convertDateInTimezone(comment.created_at)._d).format('hh:mma, MMMM DD'), this.props);
                const chunkOfReply = (!_.isEmpty(comment.replies) ? comment && comment.replies && comment.replies.slice(0, replyCount) : []);
                return (
                  <SingleComment key={index} noFloat={noFloat}>
                    <CommentContent noFloat>
                      <ImageWrapper comment={1}>
                        {this.showProfileImage(comment, false)}
                      </ImageWrapper>
                      <CommentSection>
                        <div id="addCommment" style={{ display: 'flex', justifyContent: 'space-between' }} className={"profileName"}>
                          <div>{t(comment.user_name)}</div>
                          {this.props.userId === comment.uid && <DownAngle background={1} style={{ lineHeight: '0px' }} feed>
                            <DropdownButton id="buddy" title={<img src='/public/images/menuIcon.png' style={{width:"24px", height:"auto"}}/>}>
                              <Dropdown.Item onClick={() => this.changeDeleteCommentPopup('delete', comment.comment_id)}>
                                {t("Delete Reply")}
                              </Dropdown.Item>
                            </DropdownButton>
                          </DownAngle>}
                        </div>
                        {!this.props.isChallengeOrEvent ? <React.Fragment>{ (!_.isNull(comment.core_value)&&!_.isNull(comment.shoutout_user_name)) &&<RecognitionText padding={'0px'} style={{ display: 'block', paddingBottom: "0px" }}>
                          {!_.isNull(comment.core_value) && <span className="first-span">
                            {t("Giving")}
                            <Img src={`${ImageUrl}/${comment.recognition_image}`} />
                            {this.props.t(comment.core_value)} {t("to")}
                          </span>}
                          {!_.isNull(comment.shoutout_user_name) && <span className="second-span">
                            {!_.isNull(comment.shoutout_user_name) ?
                              // <span dangerouslySetInnerHTML={{ __html: convertUnicode(comment.shoutout_user_name.replace(/￼/g, "")).split('-')[0] }} /> : null
                              <span>{DOMPurify.sanitize(this.createSafeHTML(convertUnicode(comment?.shoutout_user_name?.replace(/￼/g, ""))?.split('-')?.[0]))}</span> : null
                            }
                          </span>}
                        </RecognitionText>}
                        {/* <span className="CommentDescription" dangerouslySetInnerHTML={{ __html: getDecodedString(comment.comment).split('\\n').join('<br />') }} /> */}
                        <span className="CommentDescription">{DOMPurify.sanitize(this.createSafeHTML(getDecodedString(comment.comment).split('\\n').join('<br />')))}</span>
                        </React.Fragment>
                          :
                          // <span className="CommentDescription" dangerouslySetInnerHTML={{ __html: getDecodedString(comment.comment).split('\\n').join('<br />') }} />
                          <span className="CommentDescription">{DOMPurify.sanitize(this.createSafeHTML(getDecodedString(comment.comment).split('\\n').join('<br />')))}</span>
                        }
                        {
                          comment.image ? <div className="image"  style={{marginTop:"10px"}}>
                            <Img src={`${ImageUrl}/${comment.image}`} />
                          </div> : null
                        }
                      </CommentSection>
                      <div style={{width:"100%"}}>
                        <StyledLink noFloat={noFloat} width >
                          <Img disable={this.state.clicked} onClick={() => this.likeUnlikePost(comment.comment_id, comment.liked_status)} src={comment.liked_status ? ImageUrl+"/social-feed/like_filed.svg" : ImageUrl+"/social-feed/like.png"} />&nbsp;
                          {comment.comment_like_count !== 0 && <div>{comment.comment_like_count}</div>}
                          <div onClick={() => this.showTextField(comment?.comment_id,comment?.user_name,comment?.uid)}>&nbsp;| {t("Reply")} {chunkOfReply.length > 0 ? `. ${chunkOfReply.length}` : ''}</div>
                          <TimeContent  fullWidth={replyTextField === comment.comment_id} marginTop width style={{width:"auto"}}>{t(TimeOfComment)}</TimeContent>
                        </StyledLink>
                      </div>
                      {replyTextField === comment.comment_id && this.renderTextArea(replyText, comment.comment_id, comment.user_name)}
                      {
                        chunkOfReply.map((reply, index) => {
                          const TimeOfReply = moment(convertDateInTimezone(reply.created_at)._d).format('hh:mma, MMMM DD');
                          return (
                            <CommentContent key={reply?.comment + index} isReply noFloat={noFloat}>
                              <ImageWrapper comment={1}>
                                {this.showProfileImage(reply, false)}
                              </ImageWrapper>
                              <CommentSection isReply noFloat={noFloat}>
                                <div className={"profileName"}>
                                  {reply.user_name}
                                </div>
                                {!this.props.isChallengeOrEvent ? <RecognitionText padding={'0px'}>
                                  {!_.isNull(reply.core_value) && <span className="first-span">
                                    {t("Giving")}
                                    <Img src={`${ImageUrl}/${reply.recognition_image}`} />
                                    {this.props.t(reply.core_value)} {t("to")}
                                  </span>}
                                  {!_.isNull(reply.shoutout_user_name) && <span className="second-span">
                                    {
                                      !_.isNull(reply.shoutout_user_name) ?
                                        // <span dangerouslySetInnerHTML={{ __html: convertUnicode(reply.shoutout_user_name).split('-')[0] }} /> : null
                                        <span>{DOMPurify.sanitize(this.createSafeHTML(convertUnicode(reply?.shoutout_user_name)?.split('-')?.[0]))}</span> : null
                                    }
                                  </span>}
                                  {/* <span className="CommentDescription" dangerouslySetInnerHTML={{ __html: getDecodedString(reply?.comment).split('\\n').join('<br />') }} /> */}
                                  <span className="CommentDescription">{DOMPurify.sanitize(this.createSafeHTML(getDecodedString(reply?.comment)?.split('\\n')?.join('<br />')))}</span>
                                </RecognitionText> :/* <span className="CommentDescription" dangerouslySetInnerHTML={{ __html: getDecodedString(reply?.comment).split('\\n').join('<br />') }} /> */ <span className="CommentDescription">{DOMPurify.sanitize(this.createSafeHTML(getDecodedString(reply?.comment)?.split('\\n').join('<br />')))}</span>}
                                {
                                  reply.image ? <div className="image">
                                    <Img src={`${ImageUrl}/${reply.image}`} />
                                  </div> : null
                                }
   
                              </CommentSection>
                              <div style={{width:"100%"}}>
                                <StyledLink noFloat={noFloat} width >
                                  <Img disable={this.state.clicked} onClick={() => this.likeUnlikePostCommentReply(reply.id, reply.liked_status, comment.comment_id)} src={reply.liked_status ? ImageUrl+"/social-feed/like_filed.svg" : ImageUrl+"/social-feed/like.png"} />&nbsp;
                                  {reply.comment_reply_like_count !== 0 && <div>{reply?.comment_reply_like_count}</div>}
                                  <div onClick={() => this.showTextField(reply.id,reply?.user_name,reply?.uid)}>&nbsp;| {t("Reply")}</div>
                                  <TimeContentV2 fullWidth marginTop width style={{width:"auto"}}>{t(TimeOfReply)}</TimeContentV2>
   
                                </StyledLink>
                              </div>
                              {replyTextField === reply.id && this.renderTextArea(replyText, comment.comment_id, comment.user_name)}
                            </CommentContent>
                          )
                        })
                      }
                      {
                        (!_.isEmpty(comment.replies) && comment.replies.length > replyCount) &&
                        <ViewMoreLink isReply onClick={() => this.showMoreReplies(comment.replies.length)}>
                          {t("View More Replies")}
                        </ViewMoreLink>
                      }
                    </CommentContent>
                  </SingleComment>
                )
              }) : comments && comments?.map((comment, index) => {
                {/* const TimeOfComment = convertMonthFromDate(moment(convertDateInTimezone(comment.created_at)._d).format('hh:mma, MMM DD'), this.props); */}
                const chunkOfReply = (!_.isEmpty(comment.replies) ?comment && comment.replies && comment.replies.slice(0, replyCount) : []);
                return (
                  <SingleComment key={index} noFloat={noFloat}>
                    <CommentContent noFloat={noFloat}>
                      <CommentsWrapper>
                        <div className='profile'>
                          {this.showProfileImage(comment, false)}
                        </div>
                        <div className='commentwrap'>
                          <div className='header'>
                            <div>
                              <div className='name'>
                                {t(comment.user_name)}
                                {(comment.is_edited || this.state.editedCommentIds.includes(comment.comment_id)) ? <span style={{fontSize:'14px', fontWeight:400, color:'#989898', fontFamily:'Lato',paddingLeft:'5px'}}>{t("(edited)")}</span> : null}
                              </div>
                              <div className='time'>{t(comment?.time_ago)}</div>
                            </div>
                            <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
                              
                              <div className='menu'>
                                {this.props.userId === comment.uid && <DownAngleV2 margin feed>
                                  <DropdownButton 
                                    show={this.state.dropdownOpenId === comment.comment_id}
                                    onToggle={(isOpen) => this.handleDropdownToggle(isOpen, comment.comment_id)}
                                    title={<VerticalDotsIcon/>}
                                  >
                                    <Dropdown.Item onClick={(e) => this.handleEditClick(e, comment.comment_id, comment.comment)}>
                                      {t("Edit")}
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.changeDeleteCommentPopup('delete', comment.comment_id)}>
                                      {t("Delete")}
                                    </Dropdown.Item>
                                  </DropdownButton>
                                </DownAngleV2>}
                              </div>
                            </div>
                          </div>

                          {/* <div className='comment'> */}
                          
                          {/* {!_.isNull(comment.shoutout_user_name) && <span className="second-span" style={{marginLeft:"0px"}}>
                              {!_.isNull(comment.shoutout_user_name) ?
                                <span>{DOMPurify.sanitize(this.createSafeHTML(convertUnicode(comment?.shoutout_user_name?.replace(/￼/g, "")).split('-')[0]))}</span> : null
                              }
                            </span>} */}
                          {/* <span className="CommentDescription">{DOMPurify.sanitize(this.createSafeHTML(getDecodedString(comment?.comment)?.split('\\n')?.join('<br />')))}</span>
                            {
                              comment.image ? <div className="image">
                                <Img src={`${ImageUrl}/${comment.image}`} />
                              </div> : null
                            }
                          </div> */}
                          <div className='comment'>
                            {editingCommentId !== comment.comment_id && (
                              <>
                                <span className="CommentDescription">{DOMPurify.sanitize(this.createSafeHTML(getDecodedString(comment?.comment)?.split('\\n')?.join('<br />')))}</span>
                                {comment.image ? <div className="image"><Img src={`${ImageUrl}/${comment.image}`} /></div> : null}
                              </>
                            )}
                          </div>
                          <div className='comment'>
                            {editingCommentId === comment.comment_id ? (

                              <div style={{width:'100%', border:'1px solid #DA6C74 !important'}}>
                                <CommentBoxWrap style={{marginTop:'8px'}}>
                                  <ReplyTextPopup border={editCommentText?.length > 3000} width={'100% !important'} style={{border:'1px solid #DA6C74 !important'}}>
                                    <textarea
                                      style={{width:'100%', padding:'8px', border:'none', outline:'none', fontFamily:'Lato', fontSize:'16px', color:'#184A61', resize:'none', minHeight:'60px', background:'transparent', lineHeight:'20px'}}
                                      value={editCommentText}
                                      onChange={(e) => this.setState({ editCommentText: e.target.value.slice(0, 3000) })}
                                      autoFocus
                                    />
                                    <IconContainer isColor={editCommentText?.length > 3000} width="100% !important" cameraIcon style={{width:'100% !important', justifyContent:'space-between', position:'initial', display:'flex', margin:'8px auto auto auto'}}>
                                      <div style={{width:'24px', height:'24px', display:'flex'}}>
                                        <div style={{cursor:'pointer', margin:'auto'}} onClick={this.showEmojiPicker}>{EmojiCommentIcon()}</div>
                                      </div>
                                      <div className="commentBox">
                                        <div className="commentLength">{editCommentText.length}/3000| C</div>
                                        <div className='sendbutton' style={{marginLeft:'8px', background:'white', color:'#184A61'}} onClick={this.cancelEditComment}>
                                          {t("Cancel")}
                                        </div>
                                        <div className='sendbutton'
                                          onClick={editCommentText?.trim().length === 0 || editCommentText?.length > 3000 ? null : () => this.saveEditComment(comment.comment_id)}
                                          style={{
                                            opacity: editCommentText?.trim().length === 0 ? 0.5 : 1,
                                            cursor: editCommentText?.trim().length === 0 ? 'not-allowed' : 'pointer',
                                            background: editCommentText?.trim().length === 0 || editCommentText?.length > 3000 ? '#DCDCDC' : undefined
                                          }}>
                                          {t("Save")}
                                        </div>

                                      </div>
                                    </IconContainer>

                                  </ReplyTextPopup>
                                </CommentBoxWrap>
                                {this.state.displayEmojiPicker ? <SocialFeedsEmojiPicker comment selectEmoji={this.onEditEmojiSelect} hidePicker={this.showEmojiPicker} isCommentModal={this.props.isCommentModal} /> : null}
                              </div>
                            ) :   null}
                           
                           
                   
                          
                          </div>

                          {editingCommentId !== comment.comment_id && (<div className='timelikecomment'>
                          

                            {!isFlaggedPost ? <div className='likecomment'>
                              <Img disable={this.state.clicked} onClick={() => this.likeUnlikePost(comment.comment_id, comment.liked_status)} src={comment.liked_status ? ImageUrl+"/social-feed/like_filed.svg" : ImageUrl+"/social-feed/like.png"} />
                              {comment.comment_like_count !== 0 && <span className="commentLength">{comment.comment_like_count}</span>}
                              <span className={"disableIcon"}>|</span>
                              <span onClick={() => this.showTextField(comment.comment_id,comment.user_name, comment.uid)}>Reply</span>
                              {chunkOfReply?.length>0&&<span className={"disableIcon"}>.</span>}
                              {chunkOfReply?.length>0&& <div className="commentIcon">{ReplyCommentIcon()}</div>}
                              {chunkOfReply?.length>0&&<span className="commentLength">{chunkOfReply?.length}</span>}
                            </div> : null}
                          </div>)}
                        </div>
                      </CommentsWrapper>
                      {replyTextField === comment.comment_id && this.renderCommentArea(replyText, comment.comment_id, comment.user_name)}
                      {this.state.replyText?.length >500&&<MaxText isReplyText>You have exceeded the maximum character limit</MaxText>}
                      {/* {this.state.displayEmojiPicker ? <SocialFeedsEmojiPicker comment selectEmoji={this.onEmojiSelect} hidePicker={this.showEmojiPicker} isCommentModal={this.props.isCommentModal}></SocialFeedsEmojiPicker> : null} */}
                      {
                        chunkOfReply.map((reply, index) => {
                          {/* const TimeOfReply = moment(convertDateInTimezone(reply.created_at)._d).format('hh:mma, MMM DD'); */}
                          return (
                            <CommentContent key={reply?.comment + index} isReply noFloat={noFloat}>
                              <CommentsWrapper padding>
                                <div className='profile'>
                                  {this.showProfileImage(reply, false)}
                                </div>
                                <div className='commentwrap'>
                                  <div className='header'>
                                    <div>
                                      <div className='name'>
                                        {t(reply.user_name)}
                                        {(reply.is_edited || this.state.editedReplyIds.includes(reply.id))
                                          ? <span style={{fontSize:'14px', fontWeight:400, color:'#989898', fontFamily:'Lato', paddingLeft:'5px'}}>{t("(edited)")}</span>
                                          : null}
                                      </div>
                                      <div className='time'>{t(reply?.time_ago)}</div>
                                    </div>
                                    <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
                                      <div className='menu'>
                                        {this.props.userId === reply.uid && (
                                          <DownAngleV2 margin feed>
                                            <DropdownButton
                                              show={this.state.replyDropdownOpenId === reply.id}
                                              onToggle={(isOpen) => this.handleReplyDropdownToggle(isOpen, reply.id)}
                                              title={<VerticalDotsIcon/>}
                                            >
                                              <Dropdown.Item onClick={(e) => { e.stopPropagation(); this.setState({ replyDropdownOpenId: null }); this.startEditReply(reply.id, reply.comment); }}>
                                                {t("Edit")}
                                              </Dropdown.Item>
                                              <Dropdown.Item onClick={() => { this.setState({ replyDropdownOpenId: null }); this.changeDeleteCommentPopup('delete', reply.id); }}>
                                                {t("Delete")}
                                              </Dropdown.Item>
                                            </DropdownButton>

                                          </DownAngleV2>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className='comment'>
                                    {this.state.editingReplyId !== reply.id && (
                                      <>
                                        <span className="CommentDescription">
                                          {DOMPurify.sanitize(this.createSafeHTML(getDecodedString(reply?.comment)?.split('\\n')?.join('<br />')))}
                                        </span>
                                        {reply?.image ? <div className="image"><Img src={`${ImageUrl}/${reply?.image}`} /></div> : null}
                                      </>
                                    )}
                                    {this.state.editingReplyId === reply.id && (
                                      <div style={{width:'100%'}}>
                                        <CommentBoxWrap style={{marginTop:'8px'}}>
                                          <ReplyTextPopup border={this.state.editReplyText?.length > 3000} width={'100% !important'}>
                                            <textarea
                                              style={{width:'100%', padding:'8px', border:'none', outline:'none', fontFamily:'Lato', fontSize:'16px', color:'#184A61', resize:'none', minHeight:'60px', background:'transparent', lineHeight:'20px'}}
                                              value={this.state.editReplyText}
                                              onChange={(e) => this.setState({ editReplyText: e.target.value.slice(0, 3000) })}
                                              autoFocus
                                            />
                                            <IconContainer isColor={this.state.editReplyText?.length > 3000} width="100% !important" cameraIcon style={{width:'100% !important', justifyContent:'space-between', position:'initial', display:'flex', margin:'8px auto auto auto'}}>
                                              <div style={{width:'24px', height:'24px', display:'flex'}}>
                                                <div style={{cursor:'pointer', margin:'auto'}} onClick={this.showEmojiPicker}>{EmojiCommentIcon()}</div>
                                              </div>
                                              <div className="commentBox">
                                                <div className="commentLength">{this.state.editReplyText.length}/3000 | C</div>
                                                <div className='sendbutton' style={{marginLeft:'8px', background:'white', color:'#184A61'}} onClick={this.cancelEditReply}>
                                                  {t("Cancel")}
                                                </div>
                                                <div className='sendbutton'
                                                  onClick={this.state.editReplyText?.trim().length === 0 || this.state.editReplyText?.length > 3000 ? null : () => this.saveEditReply(comment.comment_id, reply.id)}
                                                  style={{
                                                    opacity: this.state.editReplyText?.trim().length === 0 ? 0.5 : 1,
                                                    cursor: this.state.editReplyText?.trim().length === 0 ? 'not-allowed' : 'pointer',
                                                    background: this.state.editReplyText?.trim().length === 0 || this.state.editReplyText?.length > 3000 ? '#DCDCDC' : undefined
                                                  }}>
                                                  {t("Save")}
                                                </div>

                                              </div>
                                            </IconContainer>
                                          </ReplyTextPopup>
                                        </CommentBoxWrap>
                                        {this.state.displayEmojiPicker
                                          ? <SocialFeedsEmojiPicker comment selectEmoji={this.onEditEmojiSelect} hidePicker={this.showEmojiPicker} isCommentModal={this.props.isCommentModal} />
                                          : null}
                                      </div>
                                    )}
                                  </div>

                                  {this.state.editingReplyId !== reply.id && (
                                    <div className='timelikecomment'>
                                      <div className='likecomment'>
                                        <img disable={this.state.clicked} onClick={() => this.likeUnlikePostCommentReply(reply.id, reply?.liked_status, comment.comment_id)} src={reply.liked_status ? ImageUrl+"/social-feed/like_filed.svg" : ImageUrl+"/social-feed/like.png"} />
                                        {reply.comment_reply_like_count !== 0 && <span>{reply.comment_reply_like_count}</span>}
                                        {<span className={"disableIcon"}>|</span>}
                                        <span onClick={() => this.showTextField(reply.id, reply.user_name, reply.uid)}>Reply</span>
                                      </div>
                                    </div>
                                  )}
                                </div>

                              </CommentsWrapper>
                              {replyTextField === reply.id && this.renderCommentArea(replyText, comment.comment_id, comment.user_name)}
                            </CommentContent>
                          )
                        })
                      }
                      {
                        (!_.isEmpty(comment.replies) && comment.replies.length > replyCount) &&
                        <ViewMoreLink isReply onClick={() => this.showMoreReplies(comment.replies.length)}>
                          {t("View More Replies")}
                        </ViewMoreLink>
                      }
                    </CommentContent>
                  </SingleComment>
                )
              })
            }
          </FieldContainer>
          {this.state.showDeleteCommentPopup && <DeleteCommentPopup
            showModal={this.state.showDeleteCommentPopup == 'delete'}
            onClose={this.onHideDeleteCommentPopup}
            title={this.props.t("Delete Comment")}
            subContent={this.props.t("This action cannot be undone, and the comment will be permanently removed from the system.")}
            commentId={this.state.deleteCommentId}
            postId={this.props.id}
          />}
          


        </CommentsContainer>
      </>
    )
  }
}

Comments.propTypes = {
  comments: PropTypes.array.isRequired,
  fixHeight: PropTypes.bool,
  postReply: PropTypes.func,
  id: PropTypes.number,
  replySuccess: PropTypes.string,
  noFloat: PropTypes.bool,
  fetchUserName: PropTypes.func.isRequired,
  userName: PropTypes.string,
  fetchUserProfileImage: PropTypes.func.isRequired,
  profileImage: PropTypes.string,
  fetchUserId: PropTypes.func.isRequired,
  userId: PropTypes.number,
  fetchUserPosts: PropTypes.func.isRequired,
  history: PropTypes.object,
  userCompany: PropTypes.object,
  isChallengeOrEvent: PropTypes.bool,
  enableTrigger: PropTypes.bool,
  onChange: PropTypes.func,
  likeUnlikePostComment: PropTypes.func.isRequired,
  disableLikeButton: PropTypes.func.isRequired,
  feed: PropTypes.object.isRequired,
  updationList: PropTypes.string,
  likeUnlikeCommentReply: PropTypes.func,
  handlePhotoPostModal: PropTypes.func,
  showThreeComments: PropTypes.bool,
  renderViewCommentModal: PropTypes.func,
  renderViewCommentAndGetComment: PropTypes.func,
  fromSocialFeed: PropTypes.bool,
  t: PropTypes.func,
  forCommentPopup: PropTypes.bool,
  isCommentModal:PropTypes.bool,
  commentsPagination:PropTypes.object,
  isFlaggedPost:PropTypes.bool,
  editComment: PropTypes.func,
  editCommentReply: PropTypes.func, 
};

const mapStateToProps = (state) => ({
  userName: state.profileData.userName,
  profileImage: state.profileData.profileImage,
  userId: state.profileData.userId,
  userCompany: state.profileData.userCompany,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUserName: () => dispatch(getUserName()),
  fetchUserProfileImage: () => dispatch(getUserProfileImage()),
  fetchUserId: () => dispatch(getUserId()),
  fetchUserPosts: (id, history) => dispatch(getUserPosts(id, history)),
  likeUnlikePostComment: (data, postId) => dispatch(likeUnlikePostComment(data, postId)),
  likeUnlikeCommentReply: (data, postId) => dispatch(likeUnlikeCommentReply(data, postId)),
  disableLikeButton: () => dispatch(disableButton()),
  editComment: (commentId, comment, postId) => dispatch(editCommentOnPost(commentId, comment, postId)),
  editCommentReply: (parentCommentId, replyId, comment, postId) =>dispatch(editCommentReplyOnPost(parentCommentId, replyId, comment, postId)),
  postReply: (commentId, reply, postId, shoutout, shoutOutUserName, exemplify_id, image) => dispatch(addCommentReplyOnPost(commentId, reply, postId, shoutout, shoutOutUserName, exemplify_id, image)),
});

export default connect(mapStateToProps, mapDispatchToProps)((withTranslation())(Comments));